import { DAYS_OF_WEEK } from '@repo/common';

import type { DayAvailability } from '../types/time';

export { DAYS_OF_WEEK };

export const defaultTimeRange = { start: '09:00', end: '17:00' };

export const defaultAvailability: Record<string, DayAvailability> = Object.fromEntries(
  DAYS_OF_WEEK.map(day => [day, { isAvailable: false, timeRanges: [defaultTimeRange] }]),
);
